import { useState } from 'react';

export function useLoader(defaultChoice) {
    const [value, setValue] = useState({});

    return {
        value,
        setValue,
    };
}
